<div provide-parent-form *ngIf="lineup">

	<h3>{{ 'DEFAULTS_AND_FALLBACK' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'INPUT_LOSS_IMAGE' | translate">
		<bb-logo-selector name="inputLossImage" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="lineup.inputLossImage" (entityIdChange)="lineup.inputLossImage = $event; form?.form?.markAsDirty();onConfigChanged();"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element *ngIf="!lineup.inputLossImage" [form]="form" [label]="'INPUT_LOSS_COLOR' | translate">
		<bb-color-picker-box name="inputLossColor" [(ngModel)]="lineup.inputLossColor" (ngModelChange)="onConfigChanged();"></bb-color-picker-box>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'HLS_URL_FOR_AUDIOSTREAM' | translate" [required]="containsSlideshowPlaylist">
		<input [(ngModel)]="lineup.audiostreamHlsUrl" type="text" name="audiostreamHlsUrl" (ngModelChange)="onAudioUrlChange(lineup.audiostreamHlsUrl);onConfigChanged();" [required]="containsSlideshowPlaylist" />
	</bb-form-element>

	<h3>{{ 'HTTP_LIVE_STREAMING' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'HLS_METHOD' | translate">
		<bb-radio
			name="hls-method"
			[(ngModel)]="lineup.hlsMethod"
			(ngModelChange)="onMethodChange($event)"
			[val]="'pull'"
			[label]="'PULL' | translate"
			[class.disabled]="!!lineup.cfnId"
		></bb-radio>
		<bb-radio
			name="hls-method"
			[(ngModel)]="lineup.hlsMethod"
			(ngModelChange)="onMethodChange($event)"
			[val]="'push'"
			[label]="'PUSH' | translate"
			[class.disabled]="!!lineup.cfnId"
		></bb-radio>
	</bb-form-element>

	<bb-form-element *ngIf="lineup.hlsMethod === 'pull'" [form]="form" [label]="'HLS_PULL_URL' | translate">
		<div class="input">
			<span *ngIf="!lineup.hlsPullUrl">
				{{ 'HLS_PULL_GENERATING' | translate }}
			</span>
			<span *ngIf="lineup.hlsPullUrl">
				{{ lineup.hlsPullUrl }}
				<span class="button" (click)="copyToClipboard(lineup.hlsPullUrl)" ><i class="fa fa-copy"></i>{{ 'COPY' | translate }}</span>
			</span>
		</div>
	</bb-form-element>

	<bb-form-element *ngIf="lineup.hlsMethod === 'push'" [form]="form" [label]="'HLS_ENDPOINT' | translate" [required]="true">
		<div class="endpoint">
			<input [(ngModel)]="lineup.hlsEndpoint" type="text" name="hlsEndpoint" (ngModelChange)="onEndpointChange(lineup.hlsEndpoint); onConfigChanged()" required />
			<label>
				<bb-check [(ngModel)]="lineup.hlsEndpointAuth" name="hlsEndpointAuth" (ngModelChange)="onConfigChanged();"></bb-check>
				{{ 'AUTHENTICATED' | translate }}
			</label>
		</div>
	</bb-form-element>

	<bb-form-element *ngIf="lineup.hlsMethod === 'push' && lineup.hlsEndpointAuth" [form]="form" [label]="'HLS_ENDPOINT_AUTH_USER' | translate" [required]="true">
		<input [(ngModel)]="lineup.hlsEndpointUser" type="text" name="hlsEndpointUser" required (ngModelChange)="onConfigChanged();" />
	</bb-form-element>

	<bb-form-element *ngIf="lineup.hlsMethod === 'push' && lineup.hlsEndpointAuth" [form]="form" [label]="'HLS_ENDPOINT_AUTH_PASSWORD' | translate" [required]="true">
		<bb-password-input [(ngModel)]="lineup.hlsEndpointPassword" type="password" name="hlsEndpointPassword" (ngModelChange)="onConfigChanged();"></bb-password-input>
	</bb-form-element>
</div>
